import { Component, OnInit, OnDestroy } from '@angular/core';

import { FormModalService, FormStep } from '../../services/form-modal.service';
import { Subscription } from 'rxjs';
import { trigger, transition, style, animate } from '@angular/animations';
import { FormUnifiedComponent } from '../../form-unified/form-unified.component';
import { AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-form-modal',
    imports: [FormUnifiedComponent, TranslateModule],
    templateUrl: './form-modal.component.html',
    styleUrls: ['./form-modal.component.scss'],
    animations: [
        trigger('fadeAnimation', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('300ms ease-out', style({ opacity: 1 })),
            ]),
            transition(':leave', [animate('300ms ease-in', style({ opacity: 0 }))]),
        ]),
        trigger('slideAnimation', [
            transition(':enter', [
                style({ transform: 'translateY(-50px)', opacity: 0 }),
                animate('400ms ease-out', style({ transform: 'translateY(0)', opacity: 1 })),
            ]),
            transition(':leave', [
                animate('300ms ease-in', style({ transform: 'translateY(50px)', opacity: 0 })),
            ]),
        ]),
        trigger('confirmAnimation', [
            transition(':enter', [
                style({ transform: 'scale(0.8)', opacity: 0 }),
                animate('300ms ease-out', style({ transform: 'scale(1)', opacity: 1 })),
            ]),
            transition(':leave', [
                animate('200ms ease-in', style({ transform: 'scale(0.8)', opacity: 0 })),
            ]),
        ]),
    ]
})
export class FormModalComponent implements OnInit, AfterViewInit, OnDestroy {
  currentStep: FormStep = 'none';
  serviceType: string = '';
  formData: any = {};
  showConfirmation: boolean = false;

  private subscription = new Subscription();
  @ViewChild('modalContainer') modalContainer!: ElementRef;

  constructor(private formModalService: FormModalService) {}

  ngOnInit() {
    this.subscription.add(
      this.formModalService.currentStep$.subscribe((step) => {
        this.currentStep = step;
      })
    );

    this.subscription.add(
      this.formModalService.serviceType$.subscribe((type) => {
        this.serviceType = type;
      })
    );

    this.subscription.add(
      this.formModalService.formData$.subscribe((data) => {
        this.formData = data;
      })
    );

    this.subscription.add(
      this.formModalService.showConfirmation$.subscribe((show) => {
        this.showConfirmation = show;
      })
    );
  }

  ngAfterViewInit() {
    // Set focus to modal container when it appears for accessibility
    // Use a small timeout to ensure the element is in the DOM
    requestAnimationFrame(() => {
      if (this.modalContainer && this.modalContainer.nativeElement) {
        this.modalContainer.nativeElement.focus();
      }
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  closeModal() {
    this.formModalService.closeForm();
  }

  confirmClose() {
    this.formModalService.confirmClose();
  }

  cancelClose() {
    this.formModalService.cancelClose();
  }

  // Méthode optimisée pour la navigation vers l'étape suivante
  onNextStep(data: any) {
    if (data && data.step) {
      // Sauvegarde des données du formulaire
      this.formData = { ...this.formData, ...data };
      // Mise à jour du currentStep via le service pour assurer la synchronisation
      this.formModalService.nextStep(data.step, this.formData);
    }
  }

  onPreviousStep(step: FormStep) {
    // Conserver les données actuelles lors du retour à l'étape précédente
    this.formModalService.previousStep(step);
  }

  onFormComplete(finalData: any) {
    // Fusionner toutes les données du formulaire
    const completeFormData = {
      ...this.formData,
      ...finalData,
    };
    
    console.log('Form completed with data:', completeFormData);
    
    // Ici, vous pourriez envoyer les données à votre API
    // this.apiService.submitForm(completeFormData).subscribe(...);
    
    // Marquer le formulaire comme complété et fermer la modale
    this.formModalService.completeForm();
    this.closeModal();
  }
}